/* manufacturers.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const {
    Control: {
        Action: {Button},
    },
} = uiCore;

const formatters = require("../../../cellFormaters");
const mapDataFormatters = require("../../../cellFormaters/mapDataFormatters");
const checkBoxEditor = require("../../../cellEditors/CheckBoxEditor");
const vendorEditor = require("../../../cellEditors/MapData/VendorEditor");
const netBoxManufacturersEditor = require("../../../cellEditors/MapData/NetBoxManufacturersEditor");
const getDefaultCreateValue = require("../../../cellEditors/MapData/mapDataUtil");

function createWithContext(context) {
    let ctx = context;
    ctx._isManufacturersDataValid = false;
    ctx._createManufacturersContent = function () {
        const slickTableManufacturersContainerMain = document.createElement(
            "slick-table-cmdb-container"
        );
        ctx._slickTableManufacturersContainer = document.createElement("slick-table-cmdb");
        ctx._addNewManufacturerRowButton = new Button({
            label: "Add Manufacturer +",
            active: true,
        });

        slickTableManufacturersContainerMain.appendChild(ctx._slickTableManufacturersContainer);

        const addRowButtonContainer = document.createElement("div");
        addRowButtonContainer.classList.add("add-new-rule-container");
        addRowButtonContainer.appendChild(ctx._addNewManufacturerRowButton._renderer._rootElem);
        slickTableManufacturersContainerMain.appendChild(addRowButtonContainer);

        ctx._slickManufacturersTable = undefined;
        ctx._maxSortOrderManufacturers = 0;

        ctx._columnsManufacturers = [
            {
                id: "vendor",
                field: "vendor",
                width: 400,
                name: "Gluware Vendor",
                tooltip: "Vendor",
                resizable: false,
                formatter: mapDataFormatters.vendorFormatter,
                editor: vendorEditor,
            },
            {
                id: "create",
                field: "create",
                width: 90,
                name: "Create",
                tooltip: "Create",
                resizable: false,
                headerCssClass: "centered",
                formatter: formatters.checkboxFormatter,
                editor: checkBoxEditor,
            },
            {
                id: "netBoxDeviceManufaturer",
                field: "netBoxDeviceManufaturer",
                width: 566,
                name: "NetBox Device Manufacturer",
                tooltip: "NetBox Device Manufacturer",
                resizable: false,
                formatter: mapDataFormatters.netboxManufacturerFormatter,
                editor: netBoxManufacturersEditor,
            },
            {
                id: "deleteRow",
                width: 90,
                name: "Action",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: mapDataFormatters.deleteButtonFormatter,
                headerCssClass: "centered",
            },
        ];

        ctx._manufacturersContainer.appendChild(slickTableManufacturersContainerMain);
        ctx._manufacturersContainer.appendChild(
            ctx._mCreateUnmappedCheckbox.renderer.getRootElement()
        );
    };

    ctx.registerManufacturerListeners = function () {
        ctx._addNewManufacturerRowButton.on(
            "UserClick",
            (ctx._onAddNewManufacturer = ctx._onAddNewManufacturer.bind(ctx))
        );
    };
    ctx.unregisterManufacturerListeners = function () {
        ctx._addNewManufacturerRowButton.removeAllListeners();
        ctx._unregisterManufacturersSlickTableListeners();
    };

    ctx._registerManufacturersSlickTableListeners = function () {
        if (ctx._slickManufacturersTable) {
            ctx._slickManufacturersTable.onCellChange.subscribe(ctx._onManufaturerCellChangeAction);
        }
    };

    ctx._unregisterManufacturersSlickTableListeners = function () {
        if (ctx._slickManufacturersTable) {
            ctx._slickManufacturersTable.onCellChange.unsubscribe(
                ctx._onManufaturerCellChangeAction
            );
        }
    };

    ctx._resetManufacturersGrid = function (data) {
        if (!data) {
            data = ctx._getManufacturersGridData();
        }
        if (ctx._slickManufacturersDataView) {
            ctx._slickManufacturersDataView.setItems(data);
        }
        ctx._resetManufacturersGridView(data);
    };

    ctx._resetManufacturersGridView = function (data) {
        ctx._toggleNoDataPlaceholder(!data.length, ctx._slickTableManufacturersContainer);
        ctx._enableDisableAutoCreate(!data.length, ctx._mCreateUnmappedCheckbox);
        // ctx._sortTable();
        if (ctx._slickManufacturersTable) {
            ctx._slickManufacturersTable.invalidate();
            ctx._slickManufacturersTable.render();
            ctx._slickManufacturersTable.resizeCanvas();
        }
    };

    ctx._renderManufacturersSlickGrid = function (data) {
        const mfsData = data || ctx._getManufacturersGridData() || [];
        if (!ctx._slickManufacturersTable) {
            ctx._slickTableManufacturersContainer.style.height = (mfsData.length + 1) * 80 + "px";
            ctx._slickManufacturersDataView = new Slick.Data.DataView();
            ctx._slickManufacturersDataView.setItems(mfsData);
            ctx._slickManufacturersTable = new Slick.Grid(
                ctx._slickTableManufacturersContainer,
                ctx._slickManufacturersDataView,
                ctx._columnsManufacturers,
                ctx._tableOptions
            );

            ctx._registerManufacturersSlickTableListeners();
            // ctx._slickManufacturersTable.maxSortOrder = ctx._maxSortOrder;
            ctx._slickManufacturersTable.setSelectionModel(new Slick.RowSelectionModel());
            // ctx._registerRowMovePlugin(ctx._slickManufacturersTable, ctx._slickManufacturersDataView);

            ctx._slickTableManufacturersContainer.appendChild(ctx._createNoDataPlaceholder());
            ctx._toggleNoDataPlaceholder(!mfsData.length, ctx._slickTableManufacturersContainer);
            ctx._enableDisableAutoCreate(!mfsData.length, ctx._mCreateUnmappedCheckbox);
            ctx.registerManufacturerListeners();

            ctx._slickTableManufacturersContainer.style.height = "auto";
        } else {
            // ctx._resetManufacturersData(ctx._model._selectedClass);
            ctx._resetManufacturersGrid();
        }
    };

    ctx._getManufacturersGridData = function () {
        const data = ctx._formatManufacturersData(ctx.getManufacturersMapping()) || [];
        return data.map((item) => ctx._getManufacturerRow(item));
    };

    ctx._getManufacturerRow = function (item) {
        const metaData = ctx._metaData;
        const vendorOptions = ctx._vendorOptions;
        const nbManufacturerOptions = ctx._nbManufacturersOptions;
        const defaultVendor = vendorOptions[0] && vendorOptions[0].value;
        const defaultNbManufacturer = nbManufacturerOptions[0] && nbManufacturerOptions[0].value;
        let defaultNetBoxName = getDefaultCreateValue(defaultVendor, undefined, vendorOptions);
        if (!item) {
            return {
                id: parseInt(Math.random() * 10000, 10),
                vendor: defaultVendor,
                create: false,
                netBoxDeviceManufaturer: defaultNbManufacturer,
                netBoxId: defaultNbManufacturer,
                netBoxName: defaultNetBoxName,
                metaData,
                vendorOptions,
                nbManufacturerOptions,
            };
        }
        defaultNetBoxName = getDefaultCreateValue(item.vendor, undefined, vendorOptions);
        return {
            id: item.id,
            vendor: item.vendor,
            create: item.createMissing,
            netBoxDeviceManufaturer: item.netBoxId || item.netBoxName,
            netBoxId: item.netBoxId,
            netBoxName: item.netBoxName || defaultNetBoxName,
            metaData,
            vendorOptions,
            nbManufacturerOptions,
        };
    };

    ctx._formatManufacturersData = function (data) {
        if (!data) {
            return false;
        }
        const vendors = Object.keys(data);
        const mfsData = [];
        vendors.forEach((vendor, vidx) => {
            const item = data[vendor];
            item.id = Math.random() * 1000 + vidx;
            item.vendor = vendor;
            mfsData.push(item);
        });
        // console.log(mfsData);
        return mfsData;
    };

    ctx._formatManufacturerGridToMapping = function (data) {
        const mfDataMapping = {};
        data.forEach((item) => {
            if (!mfDataMapping[item.vendor]) {
                mfDataMapping[item.vendor] = {};
            }
            mfDataMapping[item.vendor].createMissing = item.create;
            if (item.create) {
                mfDataMapping[item.vendor].netBoxId = undefined;
                mfDataMapping[item.vendor].netBoxName = item.netBoxName;
            } else {
                mfDataMapping[item.vendor].netBoxId = item.netBoxId;
            }
        });
        return mfDataMapping;
    };

    let _validateRowData = function (data, item, idx) {
        if (!item) {
            return;
        }
        if (item.create && !item.netBoxName) {
            return false;
        }
        const refVendor = item.vendor;
        const itemMatches = data.some((item, currIdx) => {
            if (idx !== currIdx && (item.vendor === refVendor || item.vendor === "ALL")) {
                return true;
            }
            return false;
        });
        if (itemMatches) {
            ctx._isManufacturersDataValid = false;
            item.isValid = false;
        } else {
            item.isValid = true;
        }
        return item.isValid;
    };

    let _validateGridData = function (data) {
        const invalidRows = [];
        data.forEach((item, idx) => {
            if (!_validateRowData(data, item, idx)) {
                ctx._slickManufacturersTable &&
                    ctx._slickManufacturersTable.getCellNode(idx, 0) &&
                    ctx._slickManufacturersTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .addClass("invalid");
                invalidRows.push(idx);
            } else {
                ctx._slickManufacturersTable &&
                    ctx._slickManufacturersTable.getCellNode(idx, 0) &&
                    ctx._slickManufacturersTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .removeClass("invalid");
            }
        });
        ctx._isManufacturersDataValid = !invalidRows.length;
        return ctx._isManufacturersDataValid;
    };

    ctx._validateManufacturersData = function () {
        if (!ctx._slickManufacturersDataView) {
            return true;
        }
        _validateGridData(ctx._slickManufacturersDataView.getItems());
        return ctx._isManufacturersDataValid;
    };

    ctx._setManufacturersData = function () {
        const mfData = {};
        const data = ctx._slickManufacturersDataView.getItems();
        mfData.mapping = ctx._formatManufacturerGridToMapping(data);
        mfData.createUnmapped = ctx._mCreateUnmappedCheckbox.getValue();
        // console.log(mfData);
        ctx._setManufacturersDataToEty(mfData);
        ctx.emit("ValueChange");
        return true;
    };

    ctx._setManufacturersDataToEty = function (data) {
        const mfData = ctx.getManufacturersData() || {};
        mfData.createUnmapped = data.createUnmapped;
        mfData.mapping = data.mapping;
        const dataSyncMapping = ctx._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.manufacturers", mfData);
        ctx._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
    };

    ctx._onAddNewManufacturer = function () {
        // console.log("add manufacturer");
        const newRow = ctx._getManufacturerRow();
        const data = ctx._slickManufacturersDataView.getItems();
        data.push(newRow);
        ctx._resetManufacturersGrid(data);
        _validateGridData(data);
        ctx._setManufacturersData();
    };

    ctx._deleteManufacturer = function (id) {
        const deleteMessage = `Are you sure you want to delete the "Manufacturer Mapping"?`;
        return ctx
            ._deleteConfirmation(deleteMessage)
            .then(() => {
                ctx._slickManufacturersDataView.deleteItem(id);
                const data = ctx._slickManufacturersDataView.getItems();
                ctx._resetManufacturersGridView(data);
                _validateGridData(data);
                ctx._setManufacturersData();
            })
            .catch((error) => error && ctx._showError(error));
    };

    ctx._onManufaturerCellChangeAction = function (/*el, args*/) {
        const data = ctx._slickManufacturersDataView.getItems();
        _validateGridData(data);
        ctx._setManufacturersData();
    }.bind(ctx);
}

module.exports = createWithContext;
